// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2ii8J","disabled":"styles_disabled__qZUrt","footerSkipBorder":"styles_footerSkipBorder__1upAt"};